import BackInStock from 'customAvailability/backInStock';
import updateProductName from '@project/components/updateProductName';
import updateBackorderLabel from '@project/components/updateBackorderLabel';
import PdpGTMEvents from '@project/components/pdpGTMEvents';
import ProductDetail from '@project/product/detail';
import handleVariation from './product/handleVariation';
import PdpCarousel from './product/pdpCarousel';
import triggerSizeSelector from './product/triggerSizeSelector';
import HandleAddToCart from './product/handleAddToCart';

document.addEventListener('DOMContentLoaded', () => {
    const productDetail = new ProductDetail();
    const pdpGTMEvents = new PdpGTMEvents();
    const pdpCarousel = new PdpCarousel();
    const handleAddToCart = new HandleAddToCart();
    const backInStock = new BackInStock();

    pdpGTMEvents.init();
    productDetail.init();
    pdpCarousel.init();
    handleAddToCart.init();
    backInStock.init();
    updateProductName();
    updateBackorderLabel();
    triggerSizeSelector();
    handleVariation(true);
});
